import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, IconButton } from "@material-ui/core";
import { Toolbar } from "../../../app/components";
import TransitEnterexitIcon from "@material-ui/icons/TransitEnterexit";
import CanvasContainer from "../../../components/Canvas/CanvasContainer";
import { selectChannelsForD3 } from "../../../store/freq-analysis/selectors";
import TechnologyLineListForCanvas from "../../Canvas/TechnologyLineListForCanvas";
import AnalysisCanvas from "../AnalysisCanvas";

const AnalysisCentralPanel = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const data = useSelector(selectChannelsForD3);
  const minHeight = TechnologyLineListForCanvas.calculateCanvasHeight(data.length);

  return (
    <Grid container item xs direction='column'>
      <Toolbar title={t('navigation_freq_analysis')}>
        <>
          <IconButton
            aria-label='close window'
            color='secondary'
            size='small'
            onClick={history.goBack} // TODO use state for going back
          >
            <TransitEnterexitIcon />
          </IconButton>
        </>
      </Toolbar>
      <Grid container item xs direction='column'>
        <Grid
          container
          item
          xs
          direction='column'
          style={{ width: '100%' }}
        >
          <CanvasContainer
            minHeight={minHeight}
            reactComponent={AnalysisCanvas}
          />
          {/*<FreqAnalysisD3*/}
          {/*  data={data}*/}
          {/*  rangeWithUnits={range}*/}
          {/*/>*/}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AnalysisCentralPanel;